class mHomepageMultilider extends HTMLDivElement {
    constructor() {
        super();
        this.tablistNode = this.querySelector('[role=tablist]');
        this.tabs = [];
        this.tabpanels = [];
        this.firstTab = null;
        this.lastTab = null;
    }

    connectedCallback() {
        if ('tabpanelClass' in this.dataset) {
            this.buildFromPageDesigner(this.dataset.tabpanelClass);
        }
        this.tabs = Array.from(this.tablistNode.querySelectorAll('[role=tab]'));
        this.tabs.forEach((tab) => {
            const tabpanel = document.getElementById(tab.getAttribute('aria-controls'));
            tab.tabIndex = -1; // eslint-disable-line no-param-reassign
            tab.setAttribute('aria-selected', 'false');
            this.tabpanels.push(tabpanel);
            tab.addEventListener('keydown', this.onKeydown.bind(this));
            tab.addEventListener('click', this.onClick.bind(this));

            if (!this.firstTab) {
                this.firstTab = tab;
            } else {
                this.lastTab = tab;
            }
        });
        this.setSelectedTab(this.tabs[0]);
    }

    disconnectedCallback() {}

    buildFromPageDesigner(tabpanelClass) {
        const tabpanels = Array.from(this.querySelectorAll(`.${tabpanelClass}`));
        tabpanels.forEach((tabpanel, index) => {
            const tabpanelId = `${this.id}-tabpanel-${index}`;
            const tabId = `${this.id}-tab-${index}`;

            // modify tabpanel
            tabpanel.id = tabpanelId; // eslint-disable-line no-param-reassign
            tabpanel.setAttribute('role', 'tabpanel');
            tabpanel.setAttribute('aria-labelledby', tabId);
            tabpanel.classList.add('is-hidden');

            // create tab button in tablist
            const tab = document.createElement('button');
            tab.id = tabId;
            tab.setAttribute('type', 'button');
            tab.setAttribute('role', 'tab');
            tab.setAttribute('aria-controls', tabpanelId);
            tab.setAttribute('aria-selected', 'false');
            const tabTitle = document.createElement('span');
            tabTitle.classList.add('focus');
            const sliderTitle = tabpanel.querySelector('.slider-title');
            if (sliderTitle) {
                tabTitle.textContent = sliderTitle.textContent;
                sliderTitle.remove();
            } else {
                tabTitle.textContent = '';
            }
            tab.appendChild(tabTitle);
            this.tablistNode.appendChild(tab);
        });
    }

    setSelectedTab(currentTab) {
        this.tabs.forEach((tab, index) => {
            if (currentTab === tab) {
                tab.setAttribute('aria-selected', 'true');
                tab.removeAttribute('tabindex');
                this.tabpanels[index].classList.remove('is-hidden');
            } else {
                tab.setAttribute('aria-selected', 'false');
                tab.tabIndex = -1; // eslint-disable-line no-param-reassign
                this.tabpanels[index].classList.add('is-hidden');
            }
        });
    }

    moveFocusToTab(currentTab) {
        currentTab.focus();
    }

    moveFocusToPreviousTab(currentTab) {
        if (currentTab === this.firstTab) {
            this.moveFocusToTab(this.lastTab);
        } else {
            const index = this.tabs.indexOf(currentTab);
            this.moveFocusToTab(this.tabs[index - 1]);
        }
    }

    moveFocusToNextTab(currentTab) {
        if (currentTab === this.lastTab) {
            this.moveFocusToTab(this.firstTab);
        } else {
            const index = this.tabs.indexOf(currentTab);
            this.moveFocusToTab(this.tabs[index + 1]);
        }
    }

    // EVENT HANDLERS

    onKeydown(event) {
        const target = event.currentTarget;
        let flag = false;

        switch (event.key) {
            case 'ArrowLeft':
                this.moveFocusToPreviousTab(target);
                flag = true;
                break;

            case 'ArrowRight':
                this.moveFocusToNextTab(target);
                flag = true;
                break;

            case 'Home':
                this.moveFocusToTab(this.firstTab);
                flag = true;
                break;

            case 'End':
                this.moveFocusToTab(this.lastTab);
                flag = true;
                break;

            default:
                break;
        }

        if (flag) {
            event.stopPropagation();
            event.preventDefault();
        }
    }

    onClick(event) {
        this.setSelectedTab(event.currentTarget);
    }
}

customElements.define('m-homepage-multislider', mHomepageMultilider, {
    extends: 'div'
});
